// index.tsx (modified)
import AddNew from "./AddNew";
import List from "./List";
import { useGlobal } from "../../../context/global";
import { useEffect, useState } from "react";
import AdminService from "../../../services/admin.service";
import { Cost, Trip, TripCost } from "../../../types/common.types";
import Filter from "./Filter";
import { useAdmin } from "../../../context/admin";
import TripsList from "./TripsList";
import Accounting from "./Accounting";
import { format } from "date-fns";
import buildCostReportPdf from "../../../utils/costReportPdf";

interface AccountingInterface {
  costs: TripCost[];
  grand_total: number;
}

export default function Costs() {
  const { currentDay, endDay } = useAdmin();
  const { setIsLoading } = useGlobal();
  const [selectedCost, setSelectedCost] = useState<string | undefined>();
  const [costs, setCosts] = useState<Cost[]>([]);
  const [trips, setTrips] = useState<Trip[]>([]);
  const [accounting, setAccounting] = useState<AccountingInterface>();

  useEffect(() => {
    async function getCost() {
      setIsLoading(true);
      try {
        const response = await (await AdminService.listCosts()).data;
        setCosts(response);
      } catch (error) {
        console.log(error);
      }
      try {
        if (selectedCost && currentDay) {
          const response = (
            await AdminService.getCostsByTripRange(selectedCost, currentDay, endDay)
          ).data;
          setTrips(response.trips);
          setAccounting(response.accounting);
        }
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    }
    getCost();
  }, [selectedCost, currentDay, endDay]);

const downloadPDFReport = () => {
  if (!accounting && trips.length === 0) return;

  const fromDate = currentDay ? format(currentDay, "dd/MM/yyyy") : "N/A";
  const toDate = endDay ? format(endDay, "dd/MM/yyyy") : fromDate;
  const doc = buildCostReportPdf(trips, accounting, { costName: selectedCost, fromDate, toDate });
  doc.save(`cost_report_${selectedCost || "all"}_${fromDate}_${toDate}.pdf`);
};

  return (
    <>
      <Filter costs={costs} setSelectedCost={setSelectedCost} />
      {/* Download button */}
      {(accounting || trips.length > 0) && (
        <div style={{ textAlign: "center", margin: "10px 0" }}>
          <button
            onClick={downloadPDFReport}
            style={{
              padding: "8px 16px",
              backgroundColor: "#2c3e50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Download PDF Report
          </button>
        </div>
      )}
      <TripsList trips={trips} />
      {accounting && <Accounting accounting={accounting} />}
      <hr />
      <AddNew />
      <List list={costs} />
    </>
  );
}